(ns promises.core)

(defn promise? [p]
  (instance? js/Promise p))

(defn timeout [seconds]
  (js/Promise. #(js/setTimeout % (* 1000 seconds))))

(defn ^js/Promise promisify [value]
  (if (promise? value)
    value
    (js/Promise.resolve value)))

(defn promise-then
  ([^js/Promise p handler]
   (.then (promisify p) handler))
  ([^js/Promise p handler catcher]
   (.then (promisify p) handler catcher)))

(defn promise-catch 
  [^js/Promise p catcher]
  (.catch (promisify p) catcher))

(defn promise-finally
  [^js/Promise p handler]
  (.finally (promisify p) handler))

(defn promise-reject 
  [err]
  (js/Promise.rejected err))

(defn promise-all 
  [promises]
  (promise-then 
    (js/Promise.all (clj->js promises))
    js->clj))